export default ({reader}) => `plugins {
  id 'com.android.application'
}

android {
  compileSdkVersion 30
  buildToolsVersion "30.0.2"

  defaultConfig {
      applicationId "com.stripe.example"
      minSdkVersion 24
      targetSdkVersion 30
      versionCode 1
      versionName "1.0"

      testInstrumentationRunner "androidx.test.runner.AndroidJUnitRunner"
  }

  buildTypes {
      release {
          minifyEnabled false
          proguardFiles getDefaultProguardFile('proguard-android-optimize.txt'), 'proguard-rules.pro'
      }
  }
  compileOptions {
      sourceCompatibility JavaVersion.VERSION_1_8
      targetCompatibility JavaVersion.VERSION_1_8
  }
}

dependencies {
  implementation fileTree(dir: 'libs', include: ['*.jar'])

  implementation 'androidx.appcompat:appcompat:1.2.0'
  implementation 'com.google.android.material:material:1.2.1'
  implementation 'androidx.constraintlayout:constraintlayout:2.0.4'
  implementation 'androidx.navigation:navigation-fragment:2.3.1'
  implementation 'androidx.navigation:navigation-ui:2.3.1'
  implementation 'org.jetbrains:annotations:16.0.01'

  {+load-stripe}
  implementation "com.stripe:stripeterminal:2.5.2"
  {/load-stripe}

  implementation 'com.facebook.stetho:stetho-okhttp3:1.5.1'
  implementation 'com.squareup.retrofit2:retrofit:2.9.0'
  implementation 'com.squareup.retrofit2:converter-gson:2.9.0'

  implementation "androidx.lifecycle:lifecycle-runtime:2.2.0"
  implementation "androidx.lifecycle:lifecycle-extensions:2.2.0"
  implementation 'org.jetbrains:annotations:15.0'
  annotationProcessor "androidx.lifecycle:lifecycle-compiler:2.2.0"

  testImplementation 'junit:junit:4.+'
  androidTestImplementation 'androidx.test.ext:junit:1.1.2'
  androidTestImplementation 'androidx.test.espresso:espresso-core:3.3.0'
}
`;
